(function ($, document, window) {
  "use strict";

  $(function () {
    const $filterForm = $('.qld__posts-filter form');

    if ($filterForm.length) {
      // Auto-submit on category select change
      $('.qld__posts-filter select').on('change', function() {
        $(this).closest('form').submit();
      });

      // Submit on search button click
      $('.qld__posts-filter button[type="submit"]').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').submit();
      });

      // Submit on Enter key in search input
      $('.qld__posts-filter input[type="text"]').on('keypress', function(e) {
        if (e.which === 13) { // Enter key
          e.preventDefault();
          $(this).closest('form').submit();
        }
      });
    }
  });
})(jQuery, document, window);
